<div class="app-titulo-pagina-v2">
    <img src="../../../assets/img/icons/bt_sac.png" alt="Icone btn_sac">
    <span>SAC - Anexos</span>
</div>
<h2>Chamado {{ mainService.sacService.chamadoSelecionado.dataRegistro| dateFormat:'yyyy-' + mainService.sacService.chamadoSelecionado.id }}</h2>

<div *ngIf="mainService.sacService.processando || mainService.downloadService.processando"
     class="text-center">
    <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<input id="length-tabela-sac-anexo" type="hidden" value="{{mainService.sacService.chamadoSelecionado.anexos?.length}}">

<div *ngIf="!mainService.downloadService.processando">
<div *ngIf="mainService.sacService.chamadoSelecionado.anexos.length" class="table-responsive">
    <table class="table table-striped table-hover">
        <thead>
            <tr>
                <th><span class="glyphicon glyphicon-arrow-down"></span> Anexo</th>
                <th>Data</th>
                <th>Usuário</th>
                <th>Ações</th>
            </tr>
        </thead>
        <tbody id="tabela-sac-anexo-body">
            <tr *ngFor="let anexo of mainService.sacService.chamadoSelecionado.anexos">
                <td>{{ anexo.nome }}</td>
                <td>{{ anexo.dataRegistro| dateFormat:'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ anexo.usuario.nome }}</td>
                <td>
                    <button type="button"
                            (click)="mainService.downloadService.getSacAnexo(anexo)"
                            class="btn app-btn-best">
                        <i class="fa fa-info-circle"></i> visualizar
                    </button>

                    <button *ngIf="anexo.usuario.id === mainService.sacService.chamadoSelecionado.cartao.id && mainService.sacService.chamadoSelecionado.status !== 'solucionado'"
                            (click)="removeAnexo(anexo)" 
                            class="btn app-btn-best">
                        <i class="fa fa-trash"></i> remover
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<button *ngIf="mainService.sacService.chamadoSelecionado.status !== 'solucionado'"
        type="button"
        class="btn app-btn-best"
        data-toggle="modal"
        data-target="#anexo">Adicionar anexo
</button>
<a (click)="mainService.loginService.changeRoute('sac')" id="btnVoltar" class="btn btn-danger">
    Voltar</a>
</div>
<br>

<div class="modal" id="anexo" tabindex="-1" role="dialog"
     aria-labelledby="anexoLabel" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
                <div class="modal-header">
                    <button class="close" data-dismiss="modal" aria-label="Fechar">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title" id="anexoLabel">Anexo</h4>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label for="arquivo">Arquivo</label>
                        <input type="file"
                               required
                               (change)="formatFile($event)"
                               id="arquivo"
                               class="form-control input-sm">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn app-btn-best" (click)="saveAnexo()" data-dismiss="modal" id="btn-modal-salvar">Salvar</button>
                    <button class="btn btn-default" data-dismiss="modal" id="btn-modal-fechar">Fechar</button>
                </div>
        </div>
    </div>
</div>




// WEBPACK FOOTER //
// ./src/app/menu-superior/sac/anexos/anexos.component.html